// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1H5uK","label":"Labeled_label__3RDnM","divider":"Labeled_divider__3OvXd"};